import { ActionIcon, Tooltip, type ActionIconProps } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { IconCopy } from '@tabler/icons-react';

export interface CopyMeetingLinkButtonProps {
  link?: string;
  size?: ActionIconProps['size'];
  variant?: ActionIconProps['variant'];
  color?: ActionIconProps['color'];
}

export function CopyMeetingLinkButton({
  link,
  size = 'lg',
  variant = 'light',
  color = 'gold',
}: CopyMeetingLinkButtonProps): JSX.Element | null {
  const trimmed = link?.trim();
  if (!trimmed) return null;

  const copyLink = (): void => {
    if (!navigator.clipboard?.writeText) {
      notifications.show({
        title: 'Copy failed',
        message: 'Clipboard is not available in this context.',
        color: 'red',
      });
      return;
    }
    void navigator.clipboard.writeText(trimmed).then(
      () => {
        notifications.show({
          title: 'Link copied',
          message: 'Meeting link copied to clipboard.',
          color: 'green',
        });
      },
      () => {
        notifications.show({
          title: 'Copy failed',
          message: 'Could not copy meeting link.',
          color: 'red',
        });
      },
    );
  };

  return (
    <Tooltip label="Copy meeting link">
      <ActionIcon size={size} variant={variant} color={color} onClick={copyLink}>
        <IconCopy size={size === 'sm' ? 14 : size === 'md' ? 16 : 20} />
      </ActionIcon>
    </Tooltip>
  );
}
